import sessionReader from '../../store/readHelpers/SessionReader';

const exitButtonSelector = {
    selectExitButtonProps(state, ownProps) {
        const { session } = state;
        return {
            disabled: ownProps?.disabled || (sessionReader.isInsidePwaChromeApp() && session.isNavigatorOffline),
        };
    },
};

export default exitButtonSelector;
